import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ListNumber from './ListNumber'
import { getTextColor } from '../../utils/helper'

const useStyles = makeStyles({
  materialList: {
    display: 'flex',
    whiteSpace: 'nowrap',
    flexWrap: 'wrap',
  },
  materialListItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 5px',
  },
  listNumberMargin: {
    marginRight: 7,
  },
  materialListItemName: {
    fontSize: '12px',
    margin: 0,
  },
})
export default function MaterialList({ elements }) {
  const classes = useStyles()

  // Filter elements if they don't have point on image
  let filteredElements = elements.filter((item) => item.pointPosition !== null)

  // If there are no elements with point indicator on image show all elements
  filteredElements = filteredElements.length === 0 ? elements : filteredElements

  return (
    <div className={classes.materialList}>
      {filteredElements.map((element, index) => {
        const customStyle = {}
        if (element.hex) {
          customStyle.backgroundColor = `#${element.hex}`
          customStyle.color = `#${getTextColor(element.hex)}`
        }
        return (
          <div className={classes.materialListItem} key={element.pointPosition}>
            <ListNumber
              number={index + 1}
              customClass={classes.listNumberMargin}
              customStyle={customStyle}
            />
            <p className={classes.materialListItemName}>{element.name}</p>
          </div>
        )
      })}
    </div>
  )
}

MaterialList.propTypes = {
  elements: PropTypes.array.isRequired,
}
MaterialList.defaultProps = {}
